function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtivos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAD61"
    },
    d: "M314.672,480.327H196.198c-12.535,0-22.696-10.161-22.696-22.696V54.367  c0-12.535,10.161-22.696,22.696-22.696h118.474c12.535,0,22.979,10.161,22.979,22.696v403.264  C337.651,470.166,327.207,480.327,314.672,480.327z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE6B8"
    },
    cx: 255.439,
    cy: 394.443,
    r: 24.863
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.622,
    y: 81.399,
    style: {
      fill: "#FFE6B8"
    },
    width: 83.628,
    height: 142.391
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAD61"
    },
    d: "M479.105,480.327H360.631c-12.535,0-22.979-10.161-22.979-22.696V54.367  c0-12.535,10.444-22.696,22.979-22.696h118.474c12.535,0,22.696,10.161,22.696,22.696v403.264  C501.801,470.166,491.639,480.327,479.105,480.327z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE6B8"
    },
    cx: 419.871,
    cy: 394.443,
    r: 24.863
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.054,
    y: 81.399,
    style: {
      fill: "#FFE6B8"
    },
    width: 83.628,
    height: 142.391
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35B38"
    },
    d: "M151.369,480.327H32.895c-12.535,0-22.696-10.161-22.696-22.696V54.367  c0-12.535,10.161-22.696,22.696-22.696h118.474c12.535,0,22.696,10.161,22.696,22.696v403.264  C174.067,470.166,163.905,480.327,151.369,480.327z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE6B8"
    },
    cx: 92.129,
    cy: 394.443,
    r: 24.863
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.323,
    y: 81.399,
    style: {
      fill: "#FFE6B8"
    },
    width: 83.628,
    height: 142.391
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M255.435,359.376c-19.334,0-35.062,15.729-35.062,35.062s15.728,35.062,35.062,35.062   s35.062-15.729,35.062-35.062S274.768,359.376,255.435,359.376z M255.435,409.101c-8.085,0-14.663-6.577-14.663-14.663   s6.578-14.663,14.663-14.663c8.086,0,14.663,6.577,14.663,14.663S263.521,409.101,255.435,409.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M297.249,71.197H213.62c-5.633,0-10.199,4.567-10.199,10.199v142.395   c0,5.632,4.566,10.199,10.199,10.199h83.628c5.632,0,10.199-4.567,10.199-10.199V81.396   C307.448,75.763,302.882,71.197,297.249,71.197z M287.049,213.592h-63.23V91.595h63.23V213.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M244.698,128.888h21.472c5.632,0,10.199-4.567,10.199-10.199s-4.567-10.199-10.199-10.199h-21.472   c-5.633,0-10.199,4.567-10.199,10.199S239.065,128.888,244.698,128.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M244.698,161.662h21.472c5.632,0,10.199-4.567,10.199-10.199s-4.567-10.199-10.199-10.199h-21.472   c-5.633,0-10.199,4.567-10.199,10.199S239.065,161.662,244.698,161.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M244.698,194.436h21.472c5.632,0,10.199-4.567,10.199-10.199s-4.567-10.199-10.199-10.199h-21.472   c-5.633,0-10.199,4.567-10.199,10.199S239.065,194.436,244.698,194.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M479.105,21.471H360.631c-8.914,0-17.012,3.51-22.979,9.201c-5.968-5.691-14.065-9.201-22.979-9.201   H196.198c-8.655,0-16.535,3.365-22.414,8.849c-5.879-5.483-13.759-8.849-22.414-8.849H32.895C14.757,21.471,0,36.228,0,54.367   v403.264c0,18.139,14.757,32.896,32.895,32.896h118.474c8.655,0,16.535-3.365,22.414-8.849c5.879,5.484,13.759,8.849,22.414,8.849   h118.475c8.914,0,17.012-3.51,22.979-9.201c5.968,5.691,14.065,9.201,22.979,9.201h118.474c18.138,0,32.895-14.757,32.895-32.896   V54.367C512,36.228,497.243,21.471,479.105,21.471z M151.37,470.128H32.895c-6.891,0-12.497-5.607-12.497-12.498V54.367   c0-6.891,5.607-12.497,12.497-12.497h118.474c5.809,0,10.691,3.99,12.085,9.37c-0.098,1.03-0.153,2.072-0.153,3.127v403.264   c0,1.056,0.055,2.098,0.153,3.128C162.061,466.138,157.179,470.128,151.37,470.128z M314.672,470.128H196.198   c-5.809,0-10.691-3.99-12.085-9.37c0.098-1.03,0.153-2.073,0.153-3.128V54.367c0-1.056-0.055-2.098-0.153-3.127   c1.394-5.379,6.276-9.37,12.085-9.37h118.475c6.927,0,12.78,5.723,12.78,12.497v403.264   C327.453,464.405,321.599,470.128,314.672,470.128z M491.602,457.63c0,6.892-5.607,12.498-12.497,12.498H360.631   c-6.927,0-12.78-5.723-12.78-12.498V54.367c0-6.774,5.852-12.497,12.78-12.497h118.474c6.891,0,12.497,5.607,12.497,12.497V457.63z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M419.868,359.376c-19.333,0-35.062,15.729-35.062,35.062s15.729,35.062,35.062,35.062   s35.062-15.729,35.062-35.062S439.2,359.376,419.868,359.376z M419.868,409.101c-8.086,0-14.663-6.577-14.663-14.663   s6.577-14.663,14.663-14.663s14.663,6.577,14.663,14.663S427.953,409.101,419.868,409.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M461.681,71.197h-83.628c-5.632,0-10.199,4.567-10.199,10.199v142.395   c0,5.632,4.567,10.199,10.199,10.199h83.628c5.632,0,10.199-4.567,10.199-10.199V81.396   C471.88,75.763,467.314,71.197,461.681,71.197z M451.482,213.592h-63.23V91.595h63.23V213.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M409.132,128.888h21.472c5.632,0,10.199-4.567,10.199-10.199s-4.567-10.199-10.199-10.199h-21.472   c-5.632,0-10.199,4.567-10.199,10.199S403.499,128.888,409.132,128.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M409.132,161.662h21.472c5.632,0,10.199-4.567,10.199-10.199s-4.567-10.199-10.199-10.199h-21.472   c-5.632,0-10.199,4.567-10.199,10.199S403.499,161.662,409.132,161.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M409.132,194.436h21.472c5.632,0,10.199-4.567,10.199-10.199s-4.567-10.199-10.199-10.199h-21.472   c-5.632,0-10.199,4.567-10.199,10.199S403.499,194.436,409.132,194.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M92.132,359.376c-19.334,0-35.062,15.729-35.062,35.062S72.799,429.5,92.132,429.5   s35.062-15.729,35.062-35.062S111.466,359.376,92.132,359.376z M92.132,409.101c-8.085,0-14.663-6.577-14.663-14.663   s6.578-14.663,14.663-14.663s14.663,6.577,14.663,14.663S100.218,409.101,92.132,409.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M133.947,71.197H50.318c-5.633,0-10.199,4.567-10.199,10.199v142.395   c0,5.632,4.566,10.199,10.199,10.199h83.629c5.633,0,10.199-4.567,10.199-10.199V81.396   C144.146,75.763,139.58,71.197,133.947,71.197z M123.748,213.592H60.517V91.595h63.231   C123.748,91.595,123.748,213.592,123.748,213.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M81.397,128.888h21.472c5.633,0,10.199-4.567,10.199-10.199s-4.566-10.199-10.199-10.199H81.397   c-5.633,0-10.199,4.567-10.199,10.199S75.764,128.888,81.397,128.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M81.397,161.662h21.472c5.633,0,10.199-4.567,10.199-10.199s-4.566-10.199-10.199-10.199H81.397   c-5.633,0-10.199,4.567-10.199,10.199S75.764,161.662,81.397,161.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M81.397,194.436h21.472c5.633,0,10.199-4.567,10.199-10.199s-4.566-10.199-10.199-10.199H81.397   c-5.633,0-10.199,4.567-10.199,10.199S75.764,194.436,81.397,194.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M49.976,332.544c5.633,0,10.199-4.567,10.199-10.199V260.13c0-5.632-4.566-10.199-10.199-10.199   s-10.199,4.567-10.199,10.199v62.215C39.777,327.977,44.343,332.544,49.976,332.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M60.175,353.962v-2.04c0-5.632-4.566-10.199-10.199-10.199s-10.199,4.567-10.199,10.199v2.04   c0,5.632,4.566,10.199,10.199,10.199S60.175,359.594,60.175,353.962z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtivos);
export default __webpack_public_path__ + "static/media/ativos.3e33aa5280d52e0f12b762a801a8cd69.svg";
export { ForwardRef as ReactComponent };